export const TRANSVERSAL_TECHNOLOGY_ID = 31;

/**
 * Core behavior values
 * Used to identify if a behavior is core (mandatory) or optional in a map
 */
export const CORE_BEHAVIOR_VALUES = {
  CORE: 1,
  OPTIONAL: 0,
} as const;

export const BEHAVIOR_DETAILS_COPIES = {
  title: 'Descripción',
  missionsTitle: 'Principales misiones del comportamiento',
  nonTransversalTechnologiesTitle: 'Enfoques del comportamiento',
  tools: 'Herramientas',
  learningActivities: 'Actividades de aprendizaje',
  transversalTechnologiesTitle: 'Transversales al comportamiento',
  coreConfigurationTitle: 'Característica del comportamiento',
  coreConfigurationQuestion: '¿Este comportamiento será obligatorio en este mapa?',
  coreOptionYes: 'Sí, este comportamiento es CORE (obligatorio)',
  coreOptionNo: 'No, este comportamiento es opcional',
};

export const BEHAVIOR_ACTIVITY_COPIES = {
  openActivity: 'Ver actividad',
};

export const BEHAVIOR_ACTIVITY_DETAILS_COPIES = {
  title: 'Actividad de aprendizaje',
  resourcesTitle: 'Recursos adicionales agregados',
  resourceLink: 'Link recurso No.',
  resourceLinkObjective: 'Link del recurso:',
  viewInformation: 'ver información',
  deliverablesTitle: 'Entregables de la actividad',
  deliverablesDescription: 'Muéstranos como lo has aplicado',
  deliverablesDescriptionReview: 'Verifica cada uno de los entregables',
  deliverable1Label: 'Entregable:',
  deliverable1Description: 'agrega el enlace de tu repositorio.',
  deliverable1DescriptionReview: 'Repositorio adjunto por el valorado.',
  deliverable1Placeholder: 'Agrega el link de tu repositorio',
  deliverable2Label: 'Entregable:',
  deliverable2Description: 'agrega un enlace.',
  deliverable2DescriptionReview: 'Enlace de soporte adjunto.',
  deliverable2Placeholder: 'Agrega un link de soporte',
  deliverable3Label: 'Entregable:',
  deliverable3Description: 'escribir respuesta.',
  deliverable3DescriptionReview: 'Respuesta del valorado.',
  deliverable3Placeholder: 'Escribe un mensaje',
  cancelButton: 'Cancelar',
  closeButton: 'Cerrar',
  saveButton: 'Guardar',
  notDelivered: 'No entregado',
};

export const EXPANDABLE_SECTION_ALT_TEXTS = {
  iconUp: 'Contraer sección',
  iconDown: 'Expandir sección',
  close: 'Cerrar',
};

export const SKILLSET_MANAGEMENT_COPIES = {
  searchPlaceholder: 'Buscar comportamientos...',
  addedToMapButton: 'Agregados al mapa',
  createBehaviorDropdown: 'Crear comportamiento',
  createPragmapowerDropdown: 'Crear pragmapower',
  createPragmapowerModalHeader: 'Creación de pragmapower',
  createPragmapowerButton: 'Crear pragmapower',
  sideModalHeaderLabel: 'Pragmapower',
  sideModalHeaderDescription: 'Nombre pragmapower nuevo',
  sideModalHeaderTitle: 'Comportamientos en la cesta',
  sideModalBehaviorHeaderTitleCrear: 'Crear comportamiento',
  sideModalBehaviorHeaderTitleEditar: 'Editar comportamiento',
  quickViewDescriptionTitle: 'Descripción',
  addToMapButton: 'Agregar al mapa',
  addToMapButtonIcon: 'assets/icons/Plus-white.svg',
  pragmapowerTypeSuffix: ' Pragmapower',
};

export const SKILLSET_GOAL_GROUP_COPIES = {
  searchPlaceholder: 'Buscar comportamientos...',
  addedToMapButton: 'Agregados al grupo',
  createBehaviorDropdown: 'Crear comportamiento',
  createPragmapowerDropdown: 'Crear pragmapower',
  createPragmapowerModalHeader: 'Creación de pragmapower',
  createPragmapowerButton: 'Crear pragmapower',
  sideModalHeaderLabel: 'Grupo de objetivos',
  sideModalHeaderDescription: '',
  sideModalHeaderTitle: 'Comportamientos en la cesta',
  sideModalBehaviorHeaderTitleCrear: 'Crear comportamiento',
  sideModalBehaviorHeaderTitleEditar: 'Editar comportamiento',
  quickViewDescriptionTitle: 'Descripción',
  addToMapButton: 'Agregar a la cesta',
  addToMapButtonIcon: 'assets/icons/Plus-white.svg',
  pragmapowerTypeSuffix: ' Pragmapower',
};
